/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'
import styled from '@emotion/styled'

import Icon, { Props } from './Icon'

interface ContainerProps {
  size: number
}

const InvertedContainer = styled.div<ContainerProps>(({ theme, size }) => ({
  background: theme.colors.main.header,
  border: `1px solid ${theme.colors.main.header}`,
  overflow: 'hidden',
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: `${size}px`,
  '& > svg': {
    marginLeft: '-1px',
    marginTop: '-1px',
  },
}))

interface IconProps extends Props {
  inverted?: boolean
}

const IconQuestionmark: React.FC<IconProps> = (props) => {
  const { inverted, ...other } = props
  const elem = (
    <Icon viewBox="0 0 21 21" {...other}>
      <path d="M10.487 0A10.5 10.5 0 1021 10.487 10.484 10.484 0 0010.487 0zm.76 16.333a1.237 1.237 0 01-.839.315 1.256 1.256 0 01-.865-.315 1.164 1.164 0 01-.367-.891 1.21 1.21 0 011.258-1.206 1.166 1.166 0 011.206 1.206 1.284 1.284 0 01-.393.891zm3.041-7.551a3.924 3.924 0 01-.655.891c-.262.262-.708.682-1.39 1.285a3.551 3.551 0 00-.446.446 2.02 2.02 0 00-.236.341 1.6 1.6 0 00-.131.315c-.026.1-.079.288-.131.551a.889.889 0 01-.97.839.968.968 0 01-.708-.288 1.093 1.093 0 01-.288-.813 3.266 3.266 0 01.21-1.18 3.4 3.4 0 01.551-.891 10.958 10.958 0 01.944-.891c.341-.315.6-.524.76-.682a1.964 1.964 0 00.393-.524 1.246 1.246 0 00.157-.629 1.428 1.428 0 00-.472-1.1 1.8 1.8 0 00-1.258-.446 1.718 1.718 0 00-1.311.446 3.186 3.186 0 00-.708 1.337c-.184.6-.524.918-1.049.918a1.009 1.009 0 01-.76-.315.978.978 0 01-.315-.708 2.848 2.848 0 01.5-1.573A3.9 3.9 0 018.416 4.8a4.59 4.59 0 012.228-.524 4.638 4.638 0 012.071.446A3.257 3.257 0 0114.1 5.9a2.826 2.826 0 01.5 1.625 2.864 2.864 0 01-.312 1.258z" />
    </Icon>
  )

  if (!!inverted) {
    return <InvertedContainer size={other.size || 14}>{elem}</InvertedContainer>
  }

  return elem
}

export default IconQuestionmark
